import { ChevronLeft, ChevronRight } from "lucide-react";

type FileNavProps = {
  index: number;
  total: number;
  onChange: (index: number) => void;
};

export const FileNav = ({ index, total, onChange }: FileNavProps) => (
  <>
    <button
      type="button"
      className="doc-viewer-icon-btn"
      aria-label="Previous file"
      title="Previous file"
      disabled={index <= 0}
      onClick={() => onChange(index - 1)}
    >
      <ChevronLeft size={18} />
    </button>
    <span className="doc-viewer-controls__value" aria-live="polite">
      {index + 1} of {total}
    </span>
    <button
      type="button"
      className="doc-viewer-icon-btn"
      aria-label="Next file"
      title="Next file"
      disabled={index >= total - 1}
      onClick={() => onChange(index + 1)}
    >
      <ChevronRight size={18} />
    </button>
  </>
);
